import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "swiper-right",
  "use": "swiper-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"swiper-right\"><path d=\"M276.7 25.893a36.571 36.571 0 0 1 51.711 0L793.82 491.3a36.571 36.571 0 0 1 0 51.785l-465.408 465.48a36.571 36.571 0 1 1-51.712-51.711l439.589-439.589L276.699 77.531a36.571 36.571 0 0 1 0-51.712z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol